import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [];

  connect() {
    this.filter();
  }

  sort(e) {
    let order = e.target.value;

    // Anonymous function to get the right sort value for a product
    let getSortVal = (node) => {
      let item = node.querySelector('.gift-list-item');
      return order === '' ? parseInt(item.dataset.sortIndex) : parseFloat(item.dataset.price);
    };

    // Set the sort order
    let gt = (order === 'desc' ? -1 : 1);
    let lt = (order === 'desc' ? 1 : -1);

    // Find the grid (which should be the .grid-x)
    let list = document.querySelector('#gift-grid');

    // Loop over the .cell children
    // Sort by data attributes within
    // Reorder
    [...list.children]
    .sort((a, b) => getSortVal(a) > getSortVal(b) ? gt : lt)
    .forEach(node => list.appendChild(node));
  }

  filter() {
    let typeFilter = document.querySelector('input[name="gift_type"]:checked').value;
    let priceFilter = document.querySelector('input[name="price_range"]:checked').value;
    let hideUnavailable = !document.querySelector('input[name="unavailable"]').checked;

    let shouldBeVisible = (node) => {
      let item = node.querySelector('.gift-list-item');
      let visible = true;

      if (visible && hideUnavailable && item.dataset.unavailable !== undefined) {
        visible = false;
      }

      if (visible && typeFilter !== '' && item.dataset.giftType !== typeFilter) {
        visible = false;
      }

      if (visible && priceFilter !== '') {
        let price = parseFloat(item.dataset.price);
        let min, max;
        [min, max] = priceFilter.split('-').map(p => parseInt(p));

        if (price < min || price > max) {
          visible = false;
        }
      }

      return visible;
    };

    // Find the grid (which should be the .grid-x)
    let list = document.querySelector('#gift-grid');

    [...list.children].forEach(node => shouldBeVisible(node) ? node.classList.remove('hide') : node.classList.add('hide'));
  }

  lock() {
    setTimeout(() => {
      document.querySelector('#gift-grid').querySelectorAll('.button').forEach(b => b.disabled = true);
    }, 100);
  }

  unlock() {
    document.querySelector('#gift-grid').querySelectorAll('.button').forEach(b => b.disabled = false);
  }
}
